import { ReactNode, FC } from 'react';
import { Input, Field, Label } from '@headlessui/react';
import cls from './inputField.module.scss';
import { ICONS } from 'shared/constants/images';
import { Loader } from 'shared/ui/loader/loader';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  children?: ReactNode;
  className?: string;
  error?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  loading?: boolean;
}

export const InputField: FC<InputFieldProps> = ({
  label,
  error = false,
  className = '',
  children,
  disabled = false,
  errorMessage,
  icon,
  iconPosition = 'right',
  loading = false,
  ...inputProps
}) => {
  const hasLeftIcon = Boolean(icon) && iconPosition === 'left';
  return (
    <Field className={`${cls.field} ${className}`}>
      {label && (
        <Label className={`${cls.label} ${error ? cls.labelError : ''}`}>
          {label}
        </Label>
      )}

      <div className={cls.inputWrapper}>
        <Input
          {...inputProps}
          className={`${error ? cls.inputError : ''} ${hasLeftIcon ? cls.inputWithLeftIcon : ''}`.trim()}
          disabled={disabled}
          aria-invalid={error}
        />

        {loading ? (
          <span
            className={`${cls.inputIcon} ${hasLeftIcon ? cls.inputIconLeft : ''}`.trim()}
          >
            <Loader size={14} color='var(--onSurfaceVariant)' />
          </span>
        ) : (
          (icon || error) && (
            <img
              src={error ? ICONS.error : icon}
              alt={error ? 'Error' : 'Icon'}
              className={`${cls.inputIcon} ${hasLeftIcon ? cls.inputIconLeft : ''}`.trim()}
            />
          )
        )}
      </div>

      {error && <span className={cls.errorMessage}>{errorMessage}</span>}

      {children}
    </Field>
  );
};
